<template>
    <article :id="app.id" class="card scroll-mt-24 overflow-hidden">
        <div class="p-7 sm:p-10">
            <div class="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
                <div>
                    <div class="flex flex-wrap gap-2">
                        <span v-for="p in platforms" :key="p" class="chip">{{ p }}</span>
                    </div>
                    <h2 class="mt-4 font-display text-[32px] font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[38px]">
                        {{ app.name }}
                    </h2>
                </div>

                <div class="flex flex-wrap gap-2">
                    <a v-for="link in app.links" :key="link.href" :href="link.href" target="_blank"
                        rel="noopener noreferrer" :class="link.type === 'youtube' ? 'btn-ghost' : 'btn-primary'">
                        <i :class="linkMeta[link.type].icon" aria-hidden="true"></i>
                        {{ linkMeta[link.type].label }}
                    </a>
                </div>
            </div>

            <div class="mt-7 grid gap-8 lg:grid-cols-[1.4fr_1fr] lg:gap-12">
                <div class="space-y-4 prose-body">
                    <p v-for="(paragraph, i) in app.description" :key="i">{{ paragraph }}</p>
                </div>

                <dl v-if="app.stack" class="space-y-4 self-start rounded-2xl bg-surface-2 p-6 text-[15px]">
                    <div v-for="row in app.stack" :key="row.label">
                        <dt class="font-medium text-ink">{{ row.label }}</dt>
                        <dd class="mt-1 leading-relaxed text-ink-2">{{ row.value }}</dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="bg-surface-2 px-5 py-7 sm:px-10 sm:py-9">
            <div class="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-1 sm:mx-0 sm:px-0 md:grid md:grid-cols-5 md:overflow-visible">
                <img v-for="(shot, i) in app.screenshots" :key="shot.src" :src="shot.src"
                    :alt="`${app.name} screenshot ${i + 1}`" :width="shot.width" :height="shot.height" loading="lazy"
                    decoding="async"
                    class="w-[46%] shrink-0 snap-start rounded-2xl shadow-soft sm:w-[30%] md:w-full" />
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        app: { type: Object, required: true }
    },
    data() {
        return {
            linkMeta: {
                appstore: { label: 'App Store', icon: 'fa-brands fa-apple' },
                playstore: { label: 'Google Play', icon: 'fa-brands fa-google-play' },
                youtube: { label: 'Watch demo', icon: 'fa-brands fa-youtube' }
            }
        };
    },
    computed: {
        platforms() {
            const types = this.app.links.map((l) => l.type);
            const p = [];
            if (types.includes('appstore')) p.push('iOS');
            if (types.includes('playstore')) p.push('Android');
            p.push('Flutter');
            return p;
        }
    }
};
</script>
